import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { GeoCountry } from '../geo-locations/geoCountry';
import { GeoRegion } from '../geo-locations/geoRegion';
import { Dropdown } from '@ami/react/core';

export class CountryAndRegionSelection extends Component {
  static propTypes = {
    isSearchMode: PropTypes.bool.isRequired,
    selectedCountryCode: PropTypes.string,
    selectedRegionCode: PropTypes.string,
    onCountrySelected: PropTypes.func.isRequired,
    onRegionSelected: PropTypes.func,
    allowRegionSelection: PropTypes.bool.isRequired,
  };

  state = {
    countries: [],
    regions: [],
    regionsInCountry: [],
    selectedCountryCode: '',
    selectedRegionCode: '',
  };

  async componentDidMount() {
    const countries = await GeoCountry.all();
    const regions = await GeoRegion.all();

    this.setState({
      countries,
      regions,
      selectedRegionCode: this.props.selectedRegionCode,
    });

    if (
      this.props.selectedCountryCode &&
      this.props.selectedCountryCode !== ''
    ) {
      this.selectCountry(this.props.selectedCountryCode);
    }

    if (this.props.selectedRegionCode && this.props.selectedRegionCode !== '') {
      this.selectRegion(this.props.selectedRegionCode);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCountrySpecified =
      prevState.selectedCountryCode &&
      prevState.selectedCountryCode !== null &&
      prevState.selectedCountryCode !== '';
    const currCountrySpecified =
      this.state.selectedCountryCode &&
      this.state.selectedCountryCode !== null &&
      this.state.selectedCountryCode !== '';
    if (
      this.props.allowRegionSelection &&
      this.props.onRegionSelected &&
      prevCountrySpecified &&
      !currCountrySpecified &&
      prevProps.selectedRegionCode &&
      prevProps.selectedRegionCode !== null &&
      prevProps.selectedRegionCode !== ''
    ) {
      this.props.onRegionSelected(null);
      this.setState({
        selectedRegionCode: null,
      });
    }
  }

  selectCountry(countryCode) {
    this.props.onCountrySelected(countryCode);
    this.setState({
      selectedCountryCode: countryCode,
      regionsInCountry: this.getCountryRegions(countryCode),
    });
  }

  selectRegion(regionCode) {
    const regionInCountry = this.state.regionsInCountry.find(
      (r) => r.regionCode === regionCode
    );
    if (!regionInCountry) {
      this.props.onRegionSelected(null);
      this.setState({
        selectedRegionCode: null,
      });
    } else {
      this.props.onRegionSelected(regionCode);
      this.setState({
        selectedRegionCode: regionCode,
      });
    }
  }

  getCountryRegions(countryCode) {
    if (!this.state.countries || !this.state.regions || !countryCode) {
      return [];
    }

    const country = this.state.countries.find(
      (x) => x.countryCode === countryCode
    );
    return this.state.regions.filter(
      (x) => x.countryCode === country.countryCode
    );
  }

  render() {
    const { allowRegionSelection } = this.props;
    const {
      countries,
      regionsInCountry,
      selectedCountryCode,
      selectedRegionCode,
    } = this.state;
    return (
      <React.Fragment>
        <div className="row gy-1 gx-1">
          <div className="col-12 col-md-6">
            <Dropdown
              placeholder={
                this.props.isSearchMode
                  ? 'All countries'
                  : 'Select a country...'
              }
              items={countries.map((c) => ({
                id: c.countryCode,
                label: c.label,
              }))}
              selectedId={selectedCountryCode}
              onChange={(selectedCountryCode) =>
                this.selectCountry(selectedCountryCode)
              }
              isClearable={this.props.isSearchMode}
            />
          </div>
          {allowRegionSelection && (
            <div className="col-12 col-md-6">
              <Dropdown
                placeholder={
                  this.props.isSearchMode
                    ? 'All provinces/states'
                    : 'Select a province/state...'
                }
                noOptions="Select a country first"
                items={regionsInCountry.map((r) => ({
                  id: r.regionCode,
                  label: r.label,
                }))}
                selectedId={selectedRegionCode}
                onChange={(selectedRegionCode) =>
                  this.selectRegion(selectedRegionCode)
                }
                isClearable={this.props.isSearchMode}
                forceSearchable={true}
              />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
